import styled from 'styled-components';

export type ImageResizeCorner = 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';

// The selection outline drawn over the currently selected image. Its position/size are set
// imperatively (via a ref) because they update on every scroll/drag frame. `pointer-events: none`
// lets clicks fall through to the image itself (keeping it selected) — only the corner handles
// capture pointer events for dragging.
export const ImageResizeOverlay = styled.div`
  position: absolute;
  z-index: 5;
  pointer-events: none;
  border: 1px dashed ${({theme}) => theme.colors.general.accent};
`;

// The insertion caret shown while dragging an image to a new position. Top/left/height are set
// imperatively as the cursor moves. A left border draws the 2px bar (px is allowed in borders).
export const ImageMoveIndicator = styled.div`
  position: absolute;
  z-index: 6;
  width: 0;
  pointer-events: none;
  border: 1px solid ${({theme}) => theme.colors.general.accent};
`;

// A draggable corner dot. Each side is toggled on/off from the corner name so the four handles
// share one styled component without any lookup/branching table.
export const ImageResizeHandle = styled.div<{$corner: ImageResizeCorner}>`
  position: absolute;
  width: ${({theme}) => theme.getSize(3)};
  height: ${({theme}) => theme.getSize(3)};
  border: 1px solid ${({theme}) => theme.colors.palettes.white[10][100]};
  border-radius: 50%;
  background-color: ${({theme}) => theme.colors.general.accent};
  pointer-events: auto;
  top: ${({$corner, theme}) =>
    $corner === 'topLeft' || $corner === 'topRight' ? `calc(${theme.getSize(3)} / -2)` : 'auto'};
  bottom: ${({$corner, theme}) =>
    $corner === 'bottomLeft' || $corner === 'bottomRight'
      ? `calc(${theme.getSize(3)} / -2)`
      : 'auto'};
  left: ${({$corner, theme}) =>
    $corner === 'topLeft' || $corner === 'bottomLeft' ? `calc(${theme.getSize(3)} / -2)` : 'auto'};
  right: ${({$corner, theme}) =>
    $corner === 'topRight' || $corner === 'bottomRight'
      ? `calc(${theme.getSize(3)} / -2)`
      : 'auto'};
  cursor: ${({$corner}) =>
    $corner === 'topLeft' || $corner === 'bottomRight' ? 'nwse-resize' : 'nesw-resize'};
`;
